import { noop } from 'lodash';

export function reduceByField<A, F extends keyof A>(
  itemsArray: readonly A[],
  field: F,
  func: (data: A) => A = (x) => x,
): Record<string, A> {
  return itemsArray.reduce(
    (all, item) => ({
      ...all,
      [item[field] as any]: func(item),
    }),
    {},
  );
}

export function reduceById<I, A extends { id: I }>(
  itemsArray: readonly A[],
  func: (obj: A) => A = (x) => x,
): Record<string, A> {
  return reduceByField(itemsArray, 'id', func);
}

export function typedKeys<T extends object>(o: T): Array<keyof T> {
  return Object.keys(o) as Array<keyof T>;
}

export function firstKeyAndValue(obj: object): [string, any] {
  let firstKey = '';

  for (firstKey in obj) {
    noop();
  }

  return [firstKey, (obj as any)[firstKey]] as any;
}

export function safeJsonParse(data: string) {
  try {
    return JSON.parse(data);
  } catch (error) {
    return {};
  }
}
